module.exports = __webpack_public_path__ + "img/d.4920ca51.png";